(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter =
          !isLargeScreen &&
          window.location.hash === '#footer-signup_form' &&
          this.querySelector('#footer-signup_form') !== null;

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-registry-announcement"]) return;
  try {
    
  if (!customElements.get('gift-registry-announcement')) {
    customElements.define('gift-registry-announcement', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.storageKey = 'wohnreich-registry-announcement-v1';
        this.preview = this.dataset.designMode === 'true';
        this.querySelectorAll('[data-dismiss]').forEach(button => button.addEventListener('click', () => this.dialog.close()));
        this.dialog.addEventListener('close', () => this.remember());
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        });
        this.querySelector('[data-registry-link]').addEventListener('click', () => this.remember());
        if (this.preview) { this.timer = setTimeout(() => this.reveal(0), 500); return; }
        try {
          const dismissed = Number(localStorage.getItem(this.storageKey));
          if (dismissed && Date.now() - dismissed < 14 * 86400000) return;
        } catch {}
        if (new URLSearchParams(location.search).has('wohnreich-quiz') || location.hash.includes('wohnreich-quiz')) return;
        this.timer = setTimeout(() => this.checkAvailability(), Number(this.dataset.delay) || 8000);
      }
      disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); }
      remember() {
        if (this.preview) return;
        try { localStorage.setItem(this.storageKey, String(Date.now())); } catch {}
      }
      async checkAvailability() {
        try {
          const path = this.dataset.path.replace(/\/$/, '');
          if (!/^\/(apps|a|tools|community)\/[a-zA-Z0-9_-]+$/.test(path)) return;
          this.controller = new AbortController();
          const timeout = setTimeout(() => this.controller.abort(), 5000);
          try {
            const response = await fetch(path + '/api/bootstrap', { credentials: 'same-origin', cache: 'no-store', signal: this.controller.signal });
            if (!response.ok) return;
            const data = await response.json();
            if (data.base !== path || typeof data.customer !== 'boolean') return;
          } finally { clearTimeout(timeout); }
          this.reveal(0);
        } catch {}
      }
      reveal(attempt) {
        if (!this.isConnected || this.dialog.open) return;
        const busy = document.hidden || [...document.querySelectorAll('dialog[open], [aria-modal="true"], #shopify-pc__banner, .shopify-pc__banner')]
          .some(element => element !== this.dialog && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
        if (busy) {
          if (attempt < 12) this.timer = setTimeout(() => this.reveal(attempt + 1), 5000);
          return;
        }
        this.dialog.showModal();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lieblingsplatz-popup"]) return;
  try {
    
  const initialiseLieblingsplatzPopup = (root = document) => {
    const popup = root.querySelector('[data-lieblingsplatz-popup]');
    if (!popup || popup.dataset.initialised === 'true') return;

    popup.dataset.initialised = 'true';
    const closeButton = popup.querySelector('[data-lieblingsplatz-popup-close]');
    const fallbackBackdrop = popup.parentElement?.querySelector('[data-lieblingsplatz-popup-fallback-backdrop]');
    const storageKey = popup.dataset.storageKey;
    const designMode = popup.dataset.designMode === 'true';
    const scrollDepth = Number(popup.dataset.scrollDepth || 10) / 100;
    const showDelay = Number(popup.dataset.showDelay || 2000);
    const fallbackMode = typeof popup.showModal !== 'function';
    let hasShown = false;
    let previouslyFocused;
    let showTimer;

    const isPermanentlyDismissed = () => {
      if (designMode) return false;
      try {
        return window.localStorage.getItem(storageKey) === 'dismissed';
      } catch (error) {
        return false;
      }
    };

    const rememberPermanentDismissal = () => {
      if (designMode) return;
      try {
        window.localStorage.setItem(storageKey, 'dismissed');
      } catch (error) {
        popup.dataset.storageUnavailable = 'true';
      }
    };

    const removeTriggers = () => {
      window.removeEventListener('scroll', handleScroll);
      document.removeEventListener('mouseout', handleExitIntent);
      window.clearTimeout(showTimer);
    };

    const restoreFocus = () => {
      if (previouslyFocused instanceof HTMLElement) {
        previouslyFocused.focus({ preventScroll: true });
      }
    };

    const closePopup = ({ permanently = false } = {}) => {
      if (permanently) rememberPermanentDismissal();
      if (fallbackMode) {
        popup.removeAttribute('open');
        fallbackBackdrop?.setAttribute('hidden', '');
        document.documentElement.classList.remove('lieblingsplatz-popup-fallback-open');
        document.removeEventListener('keydown', handleFallbackKeydown);
        restoreFocus();
      } else if (popup.open) {
        popup.close();
      }
    };

    const handleFallbackKeydown = (event) => {
      if (!popup.hasAttribute('open')) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closePopup();
        return;
      }

      if (event.key !== 'Tab') return;
      const focusableElements = [...popup.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')];
      if (focusableElements.length === 0) return;
      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      } else if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    };

    const revealPopup = () => {
      if (hasShown || isPermanentlyDismissed()) return;
      hasShown = true;
      previouslyFocused = document.activeElement;
      removeTriggers();
      if (fallbackMode) {
        popup.classList.add('lieblingsplatz-popup--fallback');
        popup.setAttribute('open', '');
        fallbackBackdrop?.removeAttribute('hidden');
        document.documentElement.classList.add('lieblingsplatz-popup-fallback-open');
        document.addEventListener('keydown', handleFallbackKeydown);
      } else {
        popup.showModal();
      }
      closeButton?.focus({ preventScroll: true });
    };

    const handleScroll = () => {
      const availableScroll = document.documentElement.scrollHeight - window.innerHeight;
      if (availableScroll <= 0) return;
      const revealAt = availableScroll * scrollDepth;
      if (window.scrollY >= revealAt) revealPopup();
    };

    const handleExitIntent = (event) => {
      if (event.relatedTarget === null && event.clientY <= 8 && window.matchMedia('(hover: hover)').matches) {
        revealPopup();
      }
    };

    closeButton?.addEventListener('click', () => closePopup({ permanently: true }));
    fallbackBackdrop?.addEventListener('click', closePopup);
    popup.addEventListener('close', restoreFocus);
    popup.addEventListener('click', (event) => {
      if (event.target === popup) closePopup();
    });

    if (designMode) {
      window.setTimeout(revealPopup, 250);
      return;
    }

    if (isPermanentlyDismissed()) return;
    window.addEventListener('scroll', handleScroll, { passive: true });
    document.addEventListener('mouseout', handleExitIntent);
    showTimer = window.setTimeout(revealPopup, showDelay);
    handleScroll();
  };

  initialiseLieblingsplatzPopup();
  document.addEventListener('shopify:section:load', (event) => initialiseLieblingsplatzPopup(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wohnreich-bestsellers"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('wohnreich-bestsellers')) {
  customElements.define('wohnreich-bestsellers', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const tabs = [...this.querySelectorAll('[data-wr-tab]')];
      const panels = [...this.querySelectorAll('[data-wr-panel]')];
      this.querySelector('.wr-bestsellers__tabs')?.setAttribute('role', 'tablist');
      const activate = (tab, focus = false) => {
        tabs.forEach(item => {
          const selected = item === tab;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
        });
        panels.forEach(panel => { panel.hidden = panel.id !== tab.dataset.wrTab; });
        if (focus) tab.focus();
      };
      tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', tab.dataset.wrTab);
        const panel = panels.find(item => item.id === tab.dataset.wrTab);
        panel?.setAttribute('role', 'tabpanel');
        panel?.setAttribute('aria-labelledby', tab.id);
        if (panel) panel.tabIndex = 0;
        tab.addEventListener('click', event => { if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return; event.preventDefault(); activate(tab); }, { signal: this.controller.signal });
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); activate(tabs[next], true); }
        }, { signal: this.controller.signal });
      });
      if (tabs.length) activate(tabs[0]);
      this.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-wr-panel]');
        const tab = tabs.find(item => item.dataset.wrTab === panel?.id);
        if (tab) activate(tab);
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wohnreich-editorial-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wr-hero-carousel')) {
    customElements.define('wr-hero-carousel', class extends HTMLElement {
      connectedCallback() {
        this.features = Array.from(this.closest('.wr-hero__visual').querySelectorAll('[data-feature-slide]'));
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        if (this.slides.length < 2) return;
        this.index = 0;
        this.timer = null;
        this.hovered = false;
        this.focused = false;
        this.visible = false;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = this.dataset.autoplay !== 'true' || this.motion.matches || !!window.Shopify?.designMode;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.pause = this.querySelector('[data-pause]');
        this.querySelector('.wr-hero__controls').hidden = false;
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index), options));
        this.querySelector('[data-prev]').addEventListener('click', () => this.show(this.index - 1), options);
        this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1), options);
        this.pause.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.updatePause();
          this.schedule();
        }, options);
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, options);
        this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
        this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); this.schedule(); }, options);
        this.querySelector('.wr-hero__dots').addEventListener('keydown', event => {
          const current = this.dots.indexOf(document.activeElement);
          if (current < 0) return;
          let next;
          if (event.key === 'ArrowRight') next = (current + 1) % this.dots.length;
          else if (event.key === 'ArrowLeft') next = (current + this.dots.length - 1) % this.dots.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.dots.length - 1;
          else return;
          event.preventDefault(); this.dots[next].focus(); this.show(next);
        }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => { if (this.motion.matches) { this.userPaused = true; this.updatePause(); } this.schedule(); }, options);
        document.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index < 0) return;
          this.userPaused = true; this.updatePause(); this.show(index);
        }, options);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); }, { threshold: .15 });
        this.observer.observe(this);
        this.updatePause();
        this.show(0);
      }
      updatePause() {
        this.pause.setAttribute('aria-label', this.userPaused ? this.pause.dataset.playLabel : this.pause.dataset.pauseLabel);
        this.pause.firstElementChild.textContent = this.userPaused ? '▶' : 'Ⅱ';
      }
      show(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.classList.toggle('is-active', active);
          slide.inert = !active;
          if (active) { slide.removeAttribute('aria-hidden'); slide.removeAttribute('tabindex'); }
          else { slide.setAttribute('aria-hidden', 'true'); slide.setAttribute('tabindex', '-1'); }
          this.dots[i].setAttribute('aria-pressed', String(active));
        });
        this.features.forEach(feature => {
          const active = Number(feature.dataset.featureSlide) === this.index;
          feature.hidden = !active;
          feature.inert = !active;
        });
        this.schedule();
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.userPaused || this.hovered || this.focused || !this.visible || document.hidden) return;
        this.timer = setTimeout(() => this.show(this.index + 1), Math.max(4000, Number(this.dataset.interval) || 6000));
      }
      disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
